module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("DAY ONE")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("“To be frank, reader, you’d be better off not visiting the city at all.”")]), _vm._v(" "), _c('p', {
    staticClass: "citation"
  }, [_vm._v("—"), _c('em', [_vm._v("The City of Sin, a Guidebook: Where To Go and Where Not To")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12557e6d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Day_One.vue
// module id = 78
// module chunks = 0